import { Form, Row } from 'react-bootstrap'

export default function StepHeader(props) {
    return (
        <div className="p-3 text-center fs-3">
            { props.text }
        </div>
    )
}